const PRICE_CSS_SELECTOR = 'pst-price';
const DISCOUNT_CSS_SELECTOR = 'pst-discount';
const SUBTOTAL_CSS_SELECTOR = 'totals__subtotal-value';
const PRICE_SERVICE_PATH = 'apps/bc/prices';
const CONFIGURABLE_PRICE_SERVICE_PATH = 'apps/bc/prices/configuration';
const SKU_DATA_ATTRIBUTE = 'data-sku';
const VARIANT_ID_DATA_ATTRIBUTE = 'data-variant-id';
const QTY_DATA_ATTRIBUTE = 'data-qty';
const PRICE_DATA_ATTRIBUTE = 'data-price';
const AUTOCOMPLETE_INPUT_SELECTOR = '#autocomplete-0-input';
const CONFIGURABLE_DATA_ATTRIBUTE = 'data-configurable';
const CONFIGURATION_DATA_ATTRIBUTE = 'data-configuration';
const CONFIGURATION_HASH_ATTRIBUTE = 'data-configuration-hash';

const currency = new Intl.NumberFormat('fi-FI', {
  style: 'currency',
  currency: 'EUR',
});

const CONFIGURABLE_ID_MAPPING = [
  {
    sku: "RÄNNIKAAPELI",
    id: '55690130424190'
  },
  {
    sku: "SULANAPITO",
    id: '55690132226430'
  }
]

const waitForElement = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

const debouncePromise = (task, ms) => {
  let t = {promise: null, cancel: (_) => void 0};
  return async (...args) => {
    try {
      t.cancel();
      t = deferred(ms);
      await t.promise;
      await task(...args);
    } catch (_) {
      // No need to log here
    }
  };
};
const deferred = (ms) => {
  let cancel,
    promise = new Promise((resolve, reject) => {
      cancel = reject;
      setTimeout(resolve, ms);
    });
  return {promise, cancel};
};

const removeLoadingClasses = (element) => {
  element.classList.remove(
    'twcss-animate-pulse',
    'twcss-h-8',
    'twcss-h-2',
    'twcss-bg-slate-200',
    'twcss-w-24',
  );
};

const addLoadingClasses = (element) => {
  element.textContent = '';
  element.classList.add(
    'twcss-animate-pulse',
    'twcss-h-8',
    'twcss-bg-slate-200',
    'twcss-w-24',
  );
};

const handlePriceResult = (data) => {
  if (
    !data?.prices ||
    !Array.isArray(data?.prices) ||
    data?.prices.length === 0
  ) {
    console.debug(
      `Price result data is not an array with elements`,
      JSON.stringify(data),
    );

    return;
  }
  const priceElementsRoot = Array.from(
    document.getElementsByClassName(PRICE_CSS_SELECTOR),
  );
  const discountElementsRoot = Array.from(
    document.getElementsByClassName(DISCOUNT_CSS_SELECTOR),
  );

  for (const priceResult of data.prices) {
    const priceElements = priceElementsRoot.filter(
      (element) => element.getAttribute(SKU_DATA_ATTRIBUTE) === priceResult.sku,
    );
    if (priceElements.length > 0 && priceResult.price) {
      for (const priceElement of priceElements) {
        removeLoadingClasses(priceElement);
        const qty = parseInt(priceElement.getAttribute(QTY_DATA_ATTRIBUTE));
        if (qty) {
          priceElement.textContent = currency.format(qty * priceResult.price);
          priceElement.setAttribute(PRICE_DATA_ATTRIBUTE, priceResult.price);
        } else {
          priceElement.textContent = currency.format(priceResult.price);
        }
      }
    }

    const discountElements = discountElementsRoot.filter(
      (element) => element.getAttribute(SKU_DATA_ATTRIBUTE) === priceResult.sku,
    );
    if (discountElements.length > 0) {
      for (const discountElement of discountElements) {
        removeLoadingClasses(discountElement);
        if (priceResult.discount > 0) {
          discountElement.textContent = `-${priceResult.discount} %`;
        } else {
          discountElement.style = 'display:none;';
        }
      }
    }
  }
};

const handleConfigurablePriceResult = (data) => {
  if (
    !data ||
    !Array.isArray(data) ||
    data.length === 0
  ) {
    console.debug(
      `Configuration price result data is not an array with elements`,
      JSON.stringify(data),
    );

    return;
  }
  const priceElementsRoot = Array.from(
    document.getElementsByClassName(PRICE_CSS_SELECTOR),
  );
  const discountElementsRoot = Array.from(
    document.getElementsByClassName(DISCOUNT_CSS_SELECTOR),
  );

  for (const configurationResult of data) {
    const priceElements = priceElementsRoot.filter(
      (element) => element.getAttribute(CONFIGURATION_HASH_ATTRIBUTE) === configurationResult.hash,
    );
    if (priceElements.length > 0 && configurationResult.price) {
      for (const priceElement of priceElements) {
        removeLoadingClasses(priceElement);
        const qty = parseInt(priceElement.getAttribute(QTY_DATA_ATTRIBUTE));
        if (qty) {
          priceElement.textContent = currency.format(qty * configurationResult.price);
          priceElement.setAttribute(PRICE_DATA_ATTRIBUTE, configurationResult.price);
        } else {
          priceElement.textContent = currency.format(configurationResult.price);
        }
      }
    }

    const discountElements = discountElementsRoot.filter(
      (element) => element.getAttribute(CONFIGURATION_HASH_ATTRIBUTE) === configurationResult.hash,
    );
    if (discountElements.length > 0) {
      for (const discountElement of discountElements) {
        removeLoadingClasses(discountElement);
        if (configurationResult.discount > 0) {
          discountElement.textContent = `-${configurationResult.discount} %`;
        } else {
          discountElement.style = 'display:none;';
        }
      }
    }
  }
};
const calculateItems = async () => {
  const priceElements = Array.from(
    document.getElementsByClassName(PRICE_CSS_SELECTOR),
  );
  if (!priceElements || priceElements.length === 0) {
    console.debug(`No price elements found from page, no need to process`);
    return;
  }
  for (const priceElement of priceElements) {
    addLoadingClasses(priceElement);
  }
  const discountElements = Array.from(
    document.getElementsByClassName(DISCOUNT_CSS_SELECTOR),
  );
  if (discountElements && discountElements.length > 0) {
    for (const discountElement of discountElements) {
      addLoadingClasses(discountElement);
    }
  }
  const skus = priceElements.filter((priceElement) =>
    !priceElement.getAttribute(CONFIGURABLE_DATA_ATTRIBUTE)).map((priceElement) =>
    priceElement.getAttribute(SKU_DATA_ATTRIBUTE),
  );
  const configurableItems = priceElements.filter(
    (priceElement) => priceElement.getAttribute(CONFIGURABLE_DATA_ATTRIBUTE) === 'true'
  ).map((priceElement) => ({
    sku: priceElement.getAttribute(SKU_DATA_ATTRIBUTE),
    configuration: JSON.parse(priceElement.getAttribute(CONFIGURATION_DATA_ATTRIBUTE)),
    variantId: priceElement.getAttribute(VARIANT_ID_DATA_ATTRIBUTE),
    hash: priceElement.getAttribute(CONFIGURATION_HASH_ATTRIBUTE)
  }))

  const promises = []
  if (skus && skus.length > 0) {
    promises.push(
      fetch(
        `/${PRICE_SERVICE_PATH}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({skus})
        }
      ),
    );
  }
  if (configurableItems && configurableItems.length > 0) {
    configurableItems.forEach(({variantId, sku, configuration, hash}) => {
      promises.push(fetch(`/${CONFIGURABLE_PRICE_SERVICE_PATH}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          configuration_sku: CONFIGURABLE_ID_MAPPING.find(idMapping => idMapping.id === variantId).sku,
          items: [configuration],
          hash
        })
      }))
    })
  }
  if (promises.length === 0) {
    return;
  }
  const [priceResult, ...configurableResults] = await Promise.all(
    promises
  );
  if (!priceResult && !configurableResults) {
    console.debug(`No price result available for skus: ${skus.join(',')}`);
    return;
  }
  const resultData = await priceResult.json();
  const configurableData = await Promise.all(configurableResults.map(async result => await result.json()))

  console.debug(`Handle priceresult`, JSON.stringify(resultData));
  handlePriceResult(resultData);
  handleConfigurablePriceResult(configurableData)
};

const calculateSubtotal = () => {
  const priceElements = Array.from(
          document.getElementsByClassName(PRICE_CSS_SELECTOR),
  );
  if (!priceElements || priceElements.length === 0) {
    console.debug(`No price elements found from page, no need to process`);
    return;
  }
  const prices = priceElements
          .map((priceElement) => {
            const sku = priceElement.getAttribute(SKU_DATA_ATTRIBUTE);
            const qty = parseInt(priceElement.getAttribute(QTY_DATA_ATTRIBUTE));
            const price = priceElement.getAttribute(PRICE_DATA_ATTRIBUTE);
            const configurationHash = priceElement.getAttribute(CONFIGURATION_HASH_ATTRIBUTE);
            if (price && qty) {
              return {sku, price, qty, configurationHash};
            }
          })
          .filter((item) => !!item)
          .filter((obj, pos, arr) => {
            // For configurator items, dedupe by configuration hash
            if (obj.sku?.includes('-configurator') && obj.configurationHash) {
              return arr.map((mapObj) => mapObj['configurationHash']).indexOf(obj['configurationHash']) === pos;
            }
            // For regular items, dedupe by SKU
            return arr.map((mapObj) => mapObj['sku']).indexOf(obj['sku']) === pos;
          });

  const subtotal = prices.reduce(
          (total, {price, qty}) => total + price * qty,
          0,
  );

  const subtotalElements = Array.from(
          document.getElementsByClassName(SUBTOTAL_CSS_SELECTOR),
  );
  if (!subtotalElements || subtotalElements.length === 0) {
    console.debug(`No subtotal elements found from page, no need to process`);
    return;
  }
  for (const subtotalElement of subtotalElements) {
    subtotalElement.textContent = currency.format(subtotal);
    removeLoadingClasses(subtotalElement);
  }
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    calculateItems()
      .then(() => calculateSubtotal())
      .then(() => console.debug(`Prices loaded`));
    waitForElement('.ais-Hits').then(() =>
      calculateItems().then(() => console.debug(`Prices loaded`)),
    );
    waitForElement('.related-products').then(() =>
      calculateItems().then(() => console.debug(`Prices loaded`)),
    );

    const subscriptions = ['cart-update', 'quantity-update', 'variant-change']
    for (const subscription of subscriptions) {
      subscribe(subscription, (event) => {
        calculateItems().then(() => calculateSubtotal()).then(() => console.debug('Prices loaded'));
      });
    }

    waitForElement(AUTOCOMPLETE_INPUT_SELECTOR).then(() => {
      const autocompleteSearch = document.querySelector(
        AUTOCOMPLETE_INPUT_SELECTOR,
      );
      autocompleteSearch.addEventListener(
        'keydown',
        debouncePromise(calculateItems, 1000),
      );
    });
  },
  false,
);
